//Color variant selector page reload
$(document).ready(() => {
  $("#multi-column-video").on("click", () => {
    $(".modal_vid_overlay").fadeIn();
    $(".modal_video").fadeIn();
  });
});

function modalClose() {
  $(".modal_vid_overlay").fadeOut();
  $(".modal_video").fadeOut();
}
